import { Component, OnInit, ViewChild } from '@angular/core';
import { ModalDirective } from 'ng-uikit-pro-standard';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { PedidoService } from 'src/app/services/pedido.service';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import * as _ from 'lodash';

@Component({
  selector: 'app-recepcion-pedidos-modal-ver-pedido',
  templateUrl: './modal-ver-pedido.component.html',
  styleUrls: ['../recepcion-pedidos.component.scss'],
  providers: [SecurityService],
})
export class RecepcionPedidosModalVerPedidoComponent implements OnInit {
  @ViewChild('verPedido', { static: true }) verPedidoModal: ModalDirective;

  // Data &  Tmp
  private rutEmpresa: number;
  cabecera: any = null;
  detallePedido: any = null;

  // Utils
  private log: any;
  total_Pedidos: any;

  constructor(private accesolocalstorage: SecurityService, private clog: ConsoleService, private messageRendererService: MessageRendererService, private pedidoService: PedidoService) {
    this.log = this.clog.log('MODAL-VER-PEDIDO');
  }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa());
  }

  load(codigo) {
    this.log(codigo);

    const inputParams = {
      empresa_rut: this.rutEmpresa,
      codigo,
    };
    this.pedidoService.obtenerPedido(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null;
      if (!ok) {
        this.messageRendererService.showErrors(mensajes);
        return;
      }

      const { cabecera, detallePedido } = respuesta;
      this.cabecera = cabecera;
      this.detallePedido = detallePedido;
      this.total_Pedidos = {
        monto_total: _.sumBy(
          detallePedido.filter((x) => x.estado_producto == true),
          'monto_neto'
        ),
        monto_bruto: _.sumBy(
          detallePedido.filter((x) => x.estado_producto == true),
          'monto_bruto'
        ),
        monto_iva: _.sumBy(
          detallePedido.filter((x) => x.estado_producto == true),
          'monto_iva_det'
        ),
      };

      this.verPedidoModal.show();
    });
  }
}
